import React, { useState } from 'react'

// bootstrap
import {
    Row, Col
} from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';

import AddNewAddressModal from './Modal/AddNewAddressModal';

export default function FormPurchaseOrdersMultipleShippingAddress(props) {
    const { vendor, addresses, getAddresses, setSAddress, sAddress } = props
    const [showAddNewAddressModal, setShowAddNewAddressModal] = useState(false);
    const addNewAddressHandler = () => {
        setShowAddNewAddressModal(true);
    };
    const closeAddNewAddressModal = () => {
        setShowAddNewAddressModal(false);
    };

    return (
        <>
            {showAddNewAddressModal &&
                <AddNewAddressModal
                    showAddNewAddressModal={showAddNewAddressModal}
                    closeAddNewAddressModal={closeAddNewAddressModal}
                    vendor={vendor}
                    getAddresses={getAddresses}
                    setSAddress={setSAddress}
                    id={vendor.vendor_id} />}
            <Row>
                <Col xs={12} md={12} lg={6} className="px-0">
                    <div className="app-header-wrapper mb-0 pad-12-L pb-1" >
                        <p className="app-heading text-capitalize app-heading-bold app-heading-label">Shipping Address</p>
                    </div>
                </Col>
                <Col xs={12} md={12} lg={6} className="px-0">
                    <div className="app-card-content st-border-light d-flex align-items-center justify-content-end" style={{ paddingRight: '4px' }}>
                        <button
                            type="button"
                            // className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(createButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                            className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2`}
                            onClick={addNewAddressHandler}
                        >
                            Add New Address
                        </button>
                    </div>
                </Col>
            </Row>

            <Row className="" style={{ paddingTop: 7 }}>
                {addresses.filter(e => e.address_type === "Shipping").map((item, index) => (

                    <Col key={index} xs={12} md={9} lg={6} className="text-capitalize bg-white border st-border-dark st-default-rounded-block st-fs-13 position-relative multiple-address-card">
                        <div>
                            <label className="st-checkbox d-inline-flex cursor-pointer">
                                <input type="checkbox" className="d-none"
                                    checked={item.address_id === sAddress.address_id}
                                    onChange={e => {
                                        setSAddress(item)
                                    }}
                                />
                                <span className="px-2 st-fs-14 st-fw-600">Default Address {index + 1}</span>
                                <span className="box d-flex align-items-center justify-content-center border">
                                    <FeatherIcon
                                        icon="check"
                                        size="15"
                                        className="icon p-0" />
                                </span>
                            </label>
                        </div>
                        <address className="p-2 st-fs-13 text-uppercase">
                            <p >{item.shipping_address}</p>
                            <p>{item.city}, {" "}{item.state},{" "}{item.shipping_zipcode}</p>
                            <p>{item.country}</p>
                            <p>{item.shipping_phone}</p>
                            {/* <button className="btn map-btn">See on map &nbsp;
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                    <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                                </svg>
                            </button> */}
                        </address>

                    </Col>
                ))}
            </Row>

        </>
    )
}
